import { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import api from "../lib/api";
import { Radio, Eye, EyeOff } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [pw, setPw] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await api.post("/auth/admin/reset-password", { token, code: code.trim(), new_password: pw });
      nav("/login");
    } catch (err) { setError(err.response?.data?.detail || "Reset failed"); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F5F3EE] p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-8">
          <div className="w-9 h-9 bg-[#1C2530] flex items-center justify-center"><Radio className="w-5 h-5 text-[#F5F3EE]" strokeWidth={1.75} /></div>
          <div className="font-mono text-sm font-semibold text-[#1C2530]">VIS · RESET ADMIN PASSWORD</div>
        </div>
        <div className="bg-white border border-[#DFDAD0] p-8 shadow-[3px_3px_0px_#DFDAD0]">
          <div className="font-mono text-[10px] uppercase tracking-[0.14em] text-[#1C2530]/60">Set a new password</div>
          <h1 className="text-2xl font-semibold tracking-tight text-[#1C2530] mt-1 mb-4">Confirm with MFA</h1>
          {!token ? (
            <div className="text-sm text-[#B23A2E]">Missing or invalid reset link.</div>
          ) : (
            <form onSubmit={submit} className="space-y-4">
              <div>
                <label className="font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60">Authenticator (MFA) code</label>
                <input data-testid="reset-code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="6-digit code"
                  className="w-full mt-1 border border-[#DFDAD0] px-3 py-2 text-sm outline-none focus:border-[#1C2530]" />
              </div>
              <div>
                <label className="font-mono text-[10px] uppercase tracking-wider text-[#1C2530]/60">New password</label>
                <div className="relative mt-1">
                  <input data-testid="reset-password" type={showPw ? "text" : "password"} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="At least 6 characters"
                    className="w-full border border-[#DFDAD0] px-3 py-2 pr-10 text-sm outline-none focus:border-[#1C2530]" />
                  <button type="button" data-testid="reset-password-toggle" onClick={() => setShowPw((v) => !v)}
                    aria-label={showPw ? "Hide password" : "Show password"}
                    className="absolute inset-y-0 right-0 flex items-center px-3 text-[#1C2530]/50 hover:text-[#1C2530]">
                    {showPw ? <EyeOff className="w-4 h-4" strokeWidth={1.75} /> : <Eye className="w-4 h-4" strokeWidth={1.75} />}
                  </button>
                </div>
              </div>
              {error && <div data-testid="reset-error" className="font-mono text-xs text-[#B23A2E] border border-[#B23A2E]/30 bg-[#B23A2E]/5 px-3 py-2">{error}</div>}
              <button type="submit" disabled={busy} data-testid="reset-submit"
                className="w-full bg-[#1C2530] text-[#F5F3EE] py-2.5 text-sm font-medium hover:bg-[#2a3644] disabled:opacity-50">
                {busy ? "Resetting…" : "Reset password"}
              </button>
            </form>
          )}
        </div>
        <Link to="/login" className="mt-4 inline-block font-mono text-[10px] uppercase text-[#1C2530]/60 hover:text-[#1C2530]">Back to sign in</Link>
      </div>
    </div>
  );
}
